import Vue from 'vue'

let loadingCount = 0;
let loading;
export default {
    // showLoading和hideLoading
    // 将同一时刻的请求合并
    showLoading(){
        if(loadingCount === 0){
            this.startLoading();
        }
        loadingCount++;
    },

    hideLoading(){
        if(loadingCount <= 0) return;
        loadingCount--;
        if(loadingCount === 0){
            this.endLoading();
        }
    },

    // loading浮层
    startLoading(){
        loading = Vue.prototype.$loading({
            borderRadius: '20%',
            padding: '1',
            fade:true
        })
        loading.show();
    },

    endLoading(){
        loading.hide();
    }
}


// WEBPACK FOOTER //
// ./src/common/js/loading.js